import { Circle, DollarSign } from 'react-feather'
import { BIRMS_DIRECT } from '@services/payment/birmsFlags'

export default [
  {
    id: 'payment',
    title: 'Payments',
    icon: <DollarSign size={20} />,
    children: [
      {
        id: 'payment-list',
        title: 'Payments',
        icon: <Circle size={12} />,
        navLink: '/payments'
      },
      // BIRMS direct: only when REACT_APP_BIRMS_DIRECT is on (see birmsFlags.js)
      ...(BIRMS_DIRECT ? [{ id: 'birms-payments', title: 'BIRMS payments', icon: <Circle size={12} />, navLink: '/payments/birms' }] : []),
      {
        id: 'sync-payment-records',
        title: 'Sync Payment Records',
        icon: <Circle size={12} />,
        navLink: '/payments/sync-records'
      },
      {
        id: 'refunds',
        title: 'Refunds',
        icon: <Circle size={12} />,
        children: [
          {
            id: 'refund-pending',
            title: 'Pending List',
            icon: <Circle size={12} />,
            navLink: '/refunds/list/pending',
            resource: 'Refund'
          },
          {
            id: 'refund-refunded',
            title: 'Refunded List',
            icon: <Circle size={12} />,
            navLink: '/refunds/list/refunded',
            resource: 'Refund'
          }
        ]
      }
    ]
  }
]
